import React from "react";
import { useNavigate } from "react-router-dom";
import { logo } from "../assets";
import { Dialog } from "@headlessui/react";
import { RxHamburgerMenu } from "react-icons/rx";

const Navbar = () => {
  const [activeNav, setActiveNav] = React.useState("Home");
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const navigations = [
    {
      name: "Home",
      href: "/",
    },
    {
      name: "Gallery",
      href: "gallery",
    },
    {
      name: "Contact",
      href: "/#contact",
    },
  ];
  return (
    <div className="z-50 w-full lg:mx-32 md:mx-20 mx-4 flex h-[120px] justify-between py-8">
      <div className="flex">
        <img
          src={logo}
          className="lg:w-[195px] md:w-[177px] w-[129px]"
          alt="logo"
        />
      </div>
      <RxHamburgerMenu
        className="h-10 w-10 text-[#B3B3B3] bg-gray-700 p-2 lg:hidden rounded-lg"
        aria-hidden="true"
        onClick={() => setMobileMenuOpen(true)}
      />

      <div className="lg:flex hidden bg-[#D9D9D9BF] rounded-[50px] text-[12px] px-1 py-1 text-white gap-5">
        {navigations.map((navigation) => (
          <a
            onClick={() => {
              navigate(navigation.href);
              setActiveNav(navigation.name);
            }}
            className={`${activeNav === navigation.name ? "bg-[#151515]" : "text-black"
              } rounded-[50px] px-8 py-1 flex items-center cursor-pointer`}
          >
            {navigation.name}
          </a>
        ))}
      </div>
      <Dialog as="div" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div
          className="absolute top-0 w-full object-none h-full bg-center"
          style={{
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <span
            id="blackOverlay"
            className="w-full h-full absolute opacity-75 bg-black"
          ></span>
        </div>
        <Dialog.Panel className="fixed inset-0 z-10 overflow-y-auto px-6 py-6 lg:hidden">
          <div className="flex items-center justify-between">
            <a
              className="custom-gradient-2 text-xl font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
              onClick={() => {
                navigate("/");
                setMobileMenuOpen(false);
              }}
            ></a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-primary-cta"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <RxHamburgerMenu className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-10 flex justify-center">
            <div className="align-top bg-[#D9D9D9BF] rounded-[20px] text-[12px] px-2 py-2 flex flex-col text-white gap-5">
              {navigations.map((navigation) => (
                <button
                  onClick={() => {
                    navigate(navigation.href);
                    setActiveNav(navigation.name);
                    setMobileMenuOpen(false);
                  }}
                  className={`${activeNav === navigation.name
                      ? "bg-[#151515]"
                      : "text-black"
                    } rounded-[50px] px-8 py-2 flex items-center`}
                >
                  {navigation.name}
                </button>
              ))}
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
};

export default Navbar;
